import {
  IPaginationParams,
  PaginationOrder,
  PAGINATION_ORDER,
} from '../api/interfaces';
import { newDate, toUnixTime } from './time';

export const sortString = (a: string, b: string) => {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};
export const sortNumber = (a: number, b: number) => a - b;
export const sortDateString = (a: string, b: string) =>
  toUnixTime(newDate(a)) - toUnixTime(newDate(b));

export const createPaginationQueryString = (
  paginationParams?: IPaginationParams,
) => {
  let queryParams: URLSearchParams | undefined;

  if (paginationParams != null) {
    const { sort, ...restParams } = paginationParams;

    queryParams = new URLSearchParams();

    Object.entries(restParams).forEach(([key, value]) => {
      if (value != null) {
        queryParams?.append(key, String(value));
      }
    });
    if (sort != null && sort.name && sort.order) {
      queryParams.append('sort', `${sort.name},${sort.order}`);
    }
  }
  return queryParams && `${queryParams}`;
};

const isPaginationOrderParam = (
  queryParam: any,
): queryParam is PaginationOrder => PAGINATION_ORDER.includes(queryParam);

export const extractPaginationSortFromQuery = (
  paginationSortQueryParam: string,
) => {
  const [sortName, sortOrder] = paginationSortQueryParam?.split(',', 2) ?? [];
  if (!isPaginationOrderParam(sortOrder)) {
    return undefined;
  }
  return {
    name: sortName,
    order: sortOrder,
  };
};
